import React from 'react';
import {
  Col,
  Card,
  CardBody,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from 'reactstrap';

const Announcements = React.memo(({ announcements }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);

  const items = announcements.map((announcement) => ({
    id: announcement.id,
    title: announcement.name || '', // Assuming 'announcement' is the title
    description: announcement.announcement,
  }));

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => (
    <CarouselItem
      tag="div"
      key={item.id}
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
    >
      <div className="d-flex flex-column justify-content-center align-items-center h-100">
        <h5 className="mt-3 lh-base fw-normal text-white">
          <b>{item.title || 'ANNOUNCEMENT'}</b>
        </h5>
        <p className="text-white-50 adjust-fs text-center">
          {item.description}
        </p>
      </div>
    </CarouselItem>
  ));

  return (
    <Col xl={8} lg={8} md={8} sm={12}>
      <Card
        className="adjust-news-card text-white shadow-primary rounded-2"
        style={{ height: '290px' }}
      >
        <CardBody className="d-flex flex-column">
          <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            className="h-100"
          >
            {slides}
            {slides.length == 0 && (
              <p className="text-center">No Announcement</p>
            )}
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
              className="carousel-indicators-rounded m-0"
            />
          </Carousel>
        </CardBody>
      </Card>
    </Col>
  );
});

export default Announcements;
